<app-training-tab
[confirmationMessage]="confirmationMessage"
[buttonLabel]="buttonLabel"
[trainingPlanDto]="trainingPlanDetails"
(update)="ifTakeQuiz? openQuiz() : updateTrainingPlan()"
[disabled]="disabled"
[showQuiz]="showQuiz"
[quizDataToDisplay]="quizDataForDocument"
[quizType]="documentProficiencyQuiz"
(reload) = "reloadDocumentTraining()"></app-training-tab>